import React from "react";

import dompurify from "dompurify";

import { Modal, Typography } from "components/Common/clearsense-ui/components";

import { snakeCaseToString, stringToSnakeCase } from "../utils";

const sanitizer = dompurify.sanitize;

const NationalRadModal = ({ showModal, onClose, selectedFile }) => {
  const detailsList = Object.fromEntries(
    Object.keys(selectedFile.details)?.map(key => {
      if (
        !Object.keys(selectedFile.highlights).includes(stringToSnakeCase(key))
      ) {
        return [key, selectedFile.details[key]];
      }

      return [key, selectedFile.highlights[stringToSnakeCase(key)]];
    })
  );

  const metadataList = Object.fromEntries(
    Object.keys(selectedFile.metadata)?.map(key => {
      if (Object.keys(selectedFile.highlights).includes(key)) {
        return [key, selectedFile.highlights[key]];
      }

      return [key, selectedFile.metadata[key]];
    })
  );

  return (
    <Modal
      isOpen={showModal}
      onClose={onClose}
      className="overflow-auto h-5/6"
      size="md"
      data-cy="result-modal"
    >
      <Modal.Body className="flex flex-col my-4 space-y-4">
        <Typography style="h3" className="flex justify-center">
          Report
        </Typography>
        {Object.entries(metadataList)?.map(([key, value]) => (
          <div className="flex space-x-4" key={key}>
            <Typography style="h5">{snakeCaseToString(key)}:</Typography>
            <p
              dangerouslySetInnerHTML={{
                __html: sanitizer(value),
              }}
            ></p>
          </div>
        ))}
        <div className="flex flex-col space-y-4">
          {Object.entries(detailsList)?.map(([key, value]) => (
            <div className="flex flex-col space-y-1" key={key}>
              <Typography style="h5">{key}</Typography>
              <p
                dangerouslySetInnerHTML={{
                  __html: sanitizer(value),
                }}
              ></p>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default NationalRadModal;
